export default __webpack_public_path__ + "static/free-2eb39b0a42a59e798af86d7af778b54b.png";